import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment, MyHttpClientFactory, DataService } from '@ups/xplat/core';
import { CompanyModel, UserCompanyModel } from '@ups/xplat/api/dto';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends DataService<CompanyModel> {
  route: string;

  constructor(httpClient: HttpClient, httpFactory: MyHttpClientFactory) {
    super(
      environment.urls.softwareSecurityAPI,
      '/api/company',
      httpClient,
      httpFactory
    );
  }

  getCompaniesByUserId(userId: string) {
    return this.httpClient.get<CompanyModel[]>(`${this.route}/${userId}`);
  }

  updateCompany(userCompany: UserCompanyModel) {
    return this.httpClient.put(`${this.route}/userCompany`, userCompany);
  }

  updateUserCompanies(userCompanies: UserCompanyModel[]) {
    return this.httpClient.put(`${this.route}/userCompanies`, userCompanies);
  }

  getUserCompaniesByUserId(userId: string) {
    return this.httpClient.get<UserCompanyModel[]>(
      `${this.route}/userCompanies?$filter=UserId eq ${userId}`
    );
  }
}
